import { create } from "zustand";
import { persist } from "zustand/middleware";

const EMPTY_ARRAY = [];

const useColumnVisibilityStore = create(
  persist(
    (set) => ({
      tables: {},

      setVisibleColumns: (tableId, columnKeys) => {
        set((state) => ({
          tables: {
            ...state.tables,
            [tableId]: columnKeys,
          },
        }));
      },
    }),
    {
      name: "column-visibility-storage",
    },
  ),
);

export const selectVisibleColumns = (tableId) => (state) =>
  state.tables[tableId] || EMPTY_ARRAY;

export default useColumnVisibilityStore;
